import {
  Box,
  Button,
  Container,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
  FormControl,
  InputAdornment,
  IconButton,
  useMediaQuery,
  Paper,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Call";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useState } from "react";
import CloseIcon from "@mui/icons-material/Close";

const ContactUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const [topic, setTopic] = useState("Product Support");
  const [countryCode, setCountryCode] = useState("+1");
  const labelSx = {
    mb: 0.8,
    fontSize: "14px",
    fontWeight: 600,
    color: "#111",
  };
  const inputSx = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: "#fff",
      height: 46,
      fontSize: "14px",
      "& fieldset": {
        borderColor: "#E6E6E6",
      },
      "&:hover fieldset": {
        borderColor: "#d7d7d7",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#ff5c9f",
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#A0A0A0",
      opacity: 1,
    },
  };

  return (
    <Box
      sx={{
        background: "#f5f5f5",
        minHeight: "100vh",
        py: { xs: 5, md: 8 },
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box textAlign="center" mb={{ xs: 4, md: 6 }}>
          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              px: 2,
              py: 0.7,
              borderRadius: "999px",
              backgroundColor: "#eceaea",
              color: "#333",
              fontSize: "12px",
              fontWeight: 500,
              mb: 1.5,
            }}
          >
            Get in touch
          </Box>

          <Typography
            sx={{
              fontSize: { xs: "24px", md: "32px" },
              fontWeight: 700,
              color: "#111",
              lineHeight: 1.2,
              mb: 1,
            }}
          >
            Contact Us
          </Typography>

          <Typography
            sx={{
              maxWidth: 520,
              mx: "auto",
              color: "#5f5f5f",
              fontSize: { xs: "14px", md: "14px" },
              lineHeight: 1.7,
            }}
          >
            Questions, feedback, or partnership ideas? We’d love to hear from
            you.
          </Typography>
        </Box>

        <Box
          component={Paper}
          elevation={2}
          sx={{
            p: { xs: 3, md: 4 },
            backgroundColor: "#fff",
            borderRadius: "13px",
            border: "2px solid transparent",
            backgroundImage:
              "linear-gradient(#fff,#fff),linear-gradient(#F5F5F5,#F857A6)",
            backgroundOrigin: "border-box",
            backgroundClip: "padding-box,border-box",
          }}
        >
          <Grid
            container
            columnSpacing={{ xs: 0, md: 6 }}
            rowSpacing={{ xs: 4, md: 0 }}
            alignItems="flex-start"
            sx={{ width: "100%" }}
          >
            <Grid item xs={12} md={5}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  pr: { md: 3 },
                  gap: 3,
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                <Box>
                  <Typography
                    sx={{
                      fontSize: { xs: "34px", md: "56px" },
                      fontWeight: 700,
                      color: "#111",
                      lineHeight: 1.1,
                      maxWidth: { xs: "100%", md: "420px" },
                      mb: 3,
                    }}
                  >
                    Have a Question or
                    <br />
                    Just Want to Chat?
                  </Typography>

                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: { xs: 4, md: 0 }, justifyContent: { xs: "center", md: "flex-start" } }}>
                    <IconButton size="small" sx={{ p: 0, color: "#E4405F" }}>
                      <InstagramIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ p: 0, color: "#1877F2" }}>
                      <FacebookIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ p: 0, color: "#0A66C2" }}>
                      <LinkedInIcon fontSize="small" />
                    </IconButton>
                    <IconButton size="small" sx={{ p: 0, color: "#111" }}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    alignItems: { xs: "center", md: "flex-start" },
                  }}
                >
                  {/* <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <PhoneIcon sx={{ color: "#ff5ca8", fontSize: 18 }} />
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#111" }}>
                      +1 - 703-973-0064
                    </Typography>
                  </Box> */}

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <EmailIcon sx={{ color: "#ff5ca8", fontSize: 18 }} />
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#111" }}>
                      cosmeticshub865@gmail.com
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                    <LocationOnIcon sx={{ color: "#ff5ca8", fontSize: 18 }} />
                    <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#111" }}>
                      INDIA
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={7} sx={{ display: "flex", justifyContent: "center" }}>
              <Box sx={{ width: "100%" }}>
                <Grid container spacing={2.5}>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={labelSx}>
                      Full Name<span style={{ color: "#ff4d6d" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Eg: Karim Zebdi"
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={labelSx}>
                      Email<span style={{ color: "#ff4d6d" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="example@gmail.com"
                      sx={inputSx}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={labelSx}>
                      Phone<span style={{ color: "#ff4d6d" }}>*</span>
                    </Typography>

                    <Box
                      sx={{
                        height: 48,
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #e8e8e8",
                        borderRadius: "10px",
                        overflow: "hidden",
                        background: "#fff",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 0.8,
                          px: 1.5,
                          borderRight: "1px solid #ececec",
                          minWidth: { xs: 90, md: 110 },
                          height: "100%",
                        }}
                      >
                        <Typography sx={{ fontSize: "22px", lineHeight: 1 }}>
                          🇺🇸
                        </Typography>

                        <Select
                          value={countryCode}
                          onChange={(e) => setCountryCode(e.target.value)}
                          variant="standard"
                          disableUnderline
                          IconComponent={KeyboardArrowDownIcon}
                          sx={{
                            fontSize: "14px",
                            "& .MuiSelect-select": {
                              p: 0,
                              display: "flex",
                              alignItems: "center",
                            },
                          }}
                        >
                          <MenuItem value="+1">+1</MenuItem>
                          <MenuItem value="+91">+91</MenuItem>
                          <MenuItem value="+44">+44</MenuItem>
                        </Select>
                      </Box>

                      <TextField
                        fullWidth
                        variant="standard"
                        placeholder="00000 00000"
                        InputProps={{
                          disableUnderline: true,
                          sx: {
                            px: 2,
                            fontSize: "14px",
                            height: 46,
                            display: "flex",
                            alignItems: "center",
                          },
                        }}
                      />
                    </Box>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <Typography sx={labelSx}>
                      Topic<span style={{ color: "#ff4d6d" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={topic}
                        onChange={(e) => setTopic(e.target.value)}
                        IconComponent={KeyboardArrowDownIcon}
                        sx={{
                          height: 48,
                          borderRadius: "10px",
                          background: "#fff",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e8e8e8",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#d7d7d7",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#ff5ca8",
                          },
                          "& .MuiSelect-select": {
                            fontSize: "14px",
                            color: "#111",
                          },
                        }}
                      >
                        <MenuItem value="Product Support">Product Support</MenuItem>
                        <MenuItem value="General Inquiry">General Inquiry</MenuItem>
                        <MenuItem value="Partnership">Partnership</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <Typography sx={labelSx}>
                      Message<span style={{ color: "#ff4d6d" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      multiline
                      rows={5}
                      placeholder="Type your message..."
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          background: "#fff",
                          "& fieldset": {
                            borderColor: "#e8e8e8",
                          },
                          "&:hover fieldset": {
                            borderColor: "#d8d8d8",
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#ff5ca8",
                          },
                        },
                        "& .MuiInputBase-input": {
                          fontSize: "14px",
                        },
                        "& .MuiInputBase-input::placeholder": {
                          color: "#9b9b9b",
                          opacity: 1,
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Button
                      fullWidth
                      variant="contained"
                      sx={{
                        height: 48,
                        borderRadius: "8px",
                        textTransform: "none",
                        fontSize: "14px",
                        fontWeight: 600,
                        color: "#fff",
                        background: "linear-gradient(90deg, #f54ea2 0%, #ff5e62 100%)",
                        boxShadow: "none",
                        "&:hover": {
                          background: "linear-gradient(90deg, #f54ea2 0%, #ff5e62 100%)",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Send Message
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default ContactUs;
